module.exports = __webpack_public_path__ + "static/media/Fresh_Pack_Blue3_Side.2261f67f.png";